/**
 * getCurrentTime returns current time, adjusted with time zone offset
 * @param serverDate {Date} date on the server
 * @param timeZoneOffset {Number} time zone as a number
 * @returns current time {Date} current time, adjusted with time zone offset
 */
export function getCurrentTime(serverDate, timeZoneOffset) {
    var currentTime = new Date(serverDate);
    var currentTimeZone = timeZoneOffset.toString();
    if (currentTimeZone.indexOf(".") === -1) {
        currentTime.setHours(currentTime.getHours() + parseInt(currentTimeZone));
        return currentTime;
    }
    var hoursDiff = parseInt(currentTimeZone);
    var minutesDiff = (parseFloat(currentTimeZone) - hoursDiff) * 60;
    currentTime.setHours(currentTime.getHours() + hoursDiff, currentTime.getMinutes() + minutesDiff);
    return currentTime;
}
//# sourceMappingURL=CurrentTimeHelper.js.map